import { faRankingStar } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { type ReactElement, useContext } from 'react'
import { Tooltip } from '~/components/Global/Elements/Tooltip/Tooltip'
import { Button } from '~/components/Global/Interactions/Button/Button'
import { ButtonVariation } from '~/components/Global/Interactions/Button/ButtonVariation'
import { AsideActionContext } from '~/utils/contextes'
import { reportTrigger } from './ShortlistReport.css'
import { ShortlistReportAside } from './ShortlistReportAside'

type ShortlistReportButtonProps = {
  shortlistId: number
}

export const ShortlistReportButton = ({
  shortlistId
}: ShortlistReportButtonProps): ReactElement => {
  const { asideAction, setAsideAction } = useContext(AsideActionContext)

  return (
    <Tooltip text="Voir le retour complet" direction="top" asChild>
      <Button
        type="button"
        variation={ButtonVariation.Neutral}
        buttonSize="extraSmall"
        className={reportTrigger}
        aria-label="Voir le retour complet"
        onClick={(event) => {
          event.stopPropagation()
          setAsideAction({
            action: <ShortlistReportAside shortlistId={shortlistId} />,
            returnTo: asideAction ?? undefined
          })
        }}
      >
        <FontAwesomeIcon icon={faRankingStar} />
      </Button>
    </Tooltip>
  )
}
